export default "__VITE_ASSET__F$CWsa6f__"